import React from 'react';
import { Card } from '../components/ui/Card';
import { UsersRoundIcon } from 'lucide-react';
export function HighValueCustomers() {
  return <div className="space-y-4 sm:space-y-6" data-id="element-1135">
      <div data-id="element-1136">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-1137">
          High Value Customers
        </h1>
        <p className="text-sm sm:text-base text-gray-600" data-id="element-1138">
          Identify and analyze your most valuable customers
        </p>
      </div>

      <Card data-id="element-1139">
        <div className="text-center py-12 sm:py-16" data-id="element-1140">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1141">
            <UsersRoundIcon className="w-8 h-8 text-orange-600" data-id="element-1142" />
          </div>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2" data-id="element-1143">
            Customer Value Analysis
          </h3>
          <p className="text-sm sm:text-base text-gray-600 max-w-md mx-auto" data-id="element-1144">
            Coming soon: Identify top customers by revenue, frequency, and
            lifetime value.
          </p>
        </div>
      </Card>
    </div>;
}